import CocktailIcon from '/public/images/cocktail_white.svg';
import DinnerIcon from '/public/images/dinner_white.svg';
import styled from "styled-components";
import Image from "next/image";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";

const ListItem = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 20px;
    margin-left: 20px;
    margin-right: 20px;

    img{
        background-color: #144733;
        padding:5px;
        border-radius: 100%;

        fill:white;
    }
`;
const ListText = styled.div`
  flex: 1;
  word-break: break-word;
  overflow-wrap: anywhere;


    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    display: flex;
    align-items: center;

    color: #000000;


`;

const ContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap:20px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`

const TourTasteSectionWrapper = styled.div`
    background-color: #F9F9F9;
    padding: 50px 0 50px 0;

    @media only screen and (${breakpoints.mobile}) {
        padding: 20px 20px;
    }
`

const ListTitle = styled.h3`
    border-radius:10px;
    color: white;
    text-align:center;
    font-size: 20px;
    font-family: 'Josefin Sans';
    text-transform: uppercase;
    margin-bottom:30px;


    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0px;
    gap: 10px;
    padding-top:25px;

    height: 60px;

    background: #144733;
    border-radius: 10px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

`;

const Title = styled.h2`
    text-transform: uppercase;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #0E3325;
    font-weight: bold;
    text-align:center;
    font-size:36px;
    // Relative, not the 24px this inherited as a div: at 36px a wrapped title
    // overlapped its own second line, which the old short titles never reached.
    line-height: 1.2;

    @media only screen and (${breakpoints.mobile}) {
        font-size:25px;
    }
`;


export default function VariantBWillTasteSection({title, food, drinks, subtext, foodLabel, drinksLabel})
{
    return (
        (title ||
            food ||
            drinks ||
            subtext) &&
        <div>
            <TourTasteSectionWrapper>
                <div className={'container_small'}>
                    <div style={{

                    }}>
                        <div>
                            <Title>{title}</Title>

                            <ContentWrapper>
                                {food && <div style={{marginBottom: '30px'}}>
                                    <ListTitle>{foodLabel ?? 'THE FOOD'}</ListTitle>
                                    {food?.map((item, index) => {
                                        return <ListItem key={index}>
                                            <Image src={DinnerIcon} alt="DinnerIcon" width={30} height={30} />
                                            <ListText>{item?.text}</ListText>
                                        </ListItem>
                                    })}
                                </div>}


                                {drinks && <div style={{marginBottom: '30px'}}>
                                    <ListTitle>{drinksLabel ?? 'THE DRINKS'}</ListTitle>
                                    {drinks?.map((item, index) => {
                                        return <ListItem key={index}>
                                            <Image src={CocktailIcon} alt={'CocktailIcon'} width={30} height={30}/>
                                            <ListText>{item?.text}</ListText>
                                        </ListItem>
                                    })}
                                </div>}
                            </ContentWrapper>

                        </div>
                    </div>
                </div>


            </TourTasteSectionWrapper>
        </div>
    )


}
